import { FXRates } from '@blk/aw-api-clients';

export type MultiCurrencyConfig = { targetCurrency: string | undefined; fxRates: FXRates | undefined };
class MultiCurrencyCache {
  private multiCurrencyConfig: MultiCurrencyConfig = {
    targetCurrency: undefined,
    fxRates: undefined,
  };

  setMultiCurrencyConfig(config: MultiCurrencyConfig): void {
    this.multiCurrencyConfig = config;
  }

  getMultiCurrencyConfig(): MultiCurrencyConfig {
    return this.multiCurrencyConfig;
  }
}

export const multiCurrencyCache = new MultiCurrencyCache();
